import { useState as d, useMemo as s, useCallback as u } from "react";
const m = () => {
  const t = typeof window < "u" && window.Notification !== void 0, [i, o] = d(t ? window.Notification.permission : void 0), n = s(() => i === "granted", [i]), r = s(() => i === "denied", [i]), a = s(() => i === "default", [i]), c = u(async () => {
    if (!t) return;
    const e = await Notification.requestPermission();
    return o(e), e;
  }, [t]);
  return {
    isAvailable: t,
    isDenied: r,
    isGranted: n,
    isPrompt: a,
    permission: i,
    requestPermission: c
  };
};
export {
  m as u
};
//# sourceMappingURL=notification-utils-ToQt-VGm.mjs.map
